// Purpose: small helpers to parse JWTs safely and check expiration.

//==============================================================================
// Parse a JWT payload (returns null if invalid).
//==============================================================================
export function parseJwt(token) {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    // pad to a multiple of 4
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

//==============================================================================
/** Check expiration using the standard `exp` claim (in seconds). */
// Returns true if expired, false if valid or unknown.
//==============================================================================
export function isExpiredFromExp(token) {
  const payload = parseJwt(token);
  if (!payload || typeof payload.exp !== 'number') return false;
  const nowSec = Math.floor(Date.now() / 1000);
  return payload.exp <= nowSec;
}
